<template>
  <div class="input-group flex-nowrap">
    <component
      :is="textEditor"
      :source="source"
      :field="fieldType"
      :language="language"
      :validation-data="validationData"
      :attribute-type="attributeType"
      :attribute-id="attributeId"
      :value="value"
      @blur="$emit('blur', $event)"
      @input="$emit('input', $event)"
      @change="$emit('change', $event)"
      @multiSelectValueUpdated="$emit('multiSelectValueUpdated', $event)"
      @valueEdited="$emit('valueEdited', $event)"
      :data-type="dataType"
      :multi-select-data="multiSelectData"
      :input-class="inputClass"
      :enable-suggestions="enableSuggestions"
      :disable-non-default-suggestions="disableNonDefaultSuggestions"
      :disable-multiselect="disableMultiSelect"
      :authorization-context="authorizationContext"
      :disable-fallback="disableFallback"
      :readonly="readonly"
      :get-overflow-container-height="getOverflowContainerHeight"
      :tooltip-text="tooltipText"
      :use-ui-locale="useUiLocale"
      v-model:showEditor="showEditor"
      :source-to-field-path="sourceToFieldPath">
      <template #append>
        <slot name="append"></slot>
      </template>
    </component>

    <div v-show="this.enableEditor">
      <div v-if="isEditorVisible()">
        <b-btn variant="light" class="btn-value-editor" @click="this.showEditor = true" data-cy="text-box-with-fallback-value-editor-btn"
          ><i class="mdp-Edit"></i
        ></b-btn>
      </div>
      <div v-else style="width: 30px">
        <!-- Empty div as a spacer -->
      </div>
    </div>
  </div>
</template>

<script>
import multivaluetextbox from "./MultiValueTextBoxWithFallback.vue";
import singlevaluetextbox from "./SingleValueTextBoxWithFallback.vue";

export default {
  props: [
    "value",
    "source",
    "field",
    "language",
    "validationData",
    "attributeType",
    "attributeId",
    "dataType",
    "multiSelectData",
    "inputClass",
    "enableSuggestions",
    "disableMultiSelect",
    "disableNonDefaultSuggestions",
    "authorizationContext",
    "disableFallback",
    "readonly",
    "getOverflowContainerHeight",
    "tooltipText",
    "enableEditor",
    "useUiLocale",
    "sourceToFieldPath"
  ],
  data: function () {
    return {
      multiselectSupportedFields: {
        valueUid: "uid",
        value: "fallbackResolvedValue",
        valueAbbreviation: "fallbackResolvedAbbreviation"
      },
      showEditor: false
    };
  },
  computed: {
    textEditor: function () {
      if (this.isMultiSelectSupported) {
        return multivaluetextbox;
      } else {
        return singlevaluetextbox;
      }
    },
    languageCode: function () {
      return this.language ? this.language.languageCode : "";
    },
    fieldType: function () {
      if (this.isMultiSelectSupported) {
        return this.multiselectSupportedFields[this.field];
      }
      return this.field;
    },
    isMultiSelectSupported: function () {
      if (
        this.source[this.languageCode] &&
        (this.source[this.languageCode].isMultiSelect || (this.multiSelectData && this.multiSelectData.isMultiSelect)) &&
        this.multiselectSupportedFields[this.field]
      )
        return true;
      return false;
    }
  },
  methods: {
    isEditorVisible() {
      if (this.isMultiSelectSupported) return false;
      if (this.field == "value") {
        return this.source[this.language.languageCode].dataType != "AttributeDataTypeInterval" && this.enableEditor;
      }
      return this.enableEditor;
    }
  }
};
</script>
